var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ui-textbox',{attrs:{"disabled":_vm.disabled,"label":_vm.label,"placeholder":_vm.placeholder,"help":_vm.help},model:{value:(_vm.textProxy),callback:function ($$v) {_vm.textProxy=$$v},expression:"textProxy"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }